import styled from 'styled-components';
import { Tab } from '@mui/material';

import {
    getColor,
    getFontWeight,
    getFontSize,
    getLineHeight,
    getLetterSpacing,
} from '@process-advisor/process-miner/shared/theme';

const borderColor = getColor('borderColor');
const activeMenuTextColor = getColor('blue');

export const StyledTab = styled(Tab)`
    text-transform: none;
    color: ${getColor('gray')};
    background-color: ${getColor('white')};
    font-weight: ${getFontWeight('normal')};
    font-size: ${getFontSize('small')};
    line-height: ${getLineHeight('normal')};
    letter-spacing: ${getLetterSpacing('normal')};
    border-bottom: 0.5px solid ${borderColor};
    border-right: 0.5px solid ${borderColor};
    min-width: 10px;
    padding: 10px 10px;

    &.Mui-selected {
        color: ${activeMenuTextColor};
    }

    &:focus {
        color: ${activeMenuTextColor};
    }
`;
